var map = {
	"./android/Device": 988,
	"./androidtv/Device": 1579,
	"./arris/Device": 1584,
	"./hisense/Device": 1595,
	"./lg/Device": 1603,
	"./nagra/Device": 1612,
	"./netrange/Device": 1623,
	"./opera/Device": 1631,
	"./polaroid/Device": 1639,
	"./ps4/Device": 1647,
	"./samsung/Device": 1655,
	"./seirobotics/Device": 1663,
	"./sony/Device": 1668,
	"./stbcoship/Device": 1676,
	"./stbcoship9108/Device": 1680,
	"./stbhuawei/Device": 1684,
	"./stbkaon/Device": 1688,
	"./tizen/Device": 1691,
	"./web0s/Device": 1700,
	"./workstation/Device": 628,
	"./workstationChafari/Device": 1714,
	"./zeasn/Device": 1722,
	"./zte/Device": 1730
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 987;


//////////////////
// WEBPACK FOOTER
// ./src/devices ^\.\/.*\/Device$
// module id = 987
// module chunks = 0